/* project files imports */
import Services from "constants/service";

export const ServiceLabels = new Map<Services, string>([
  [Services.SPOTIFY, "Spotify"],
  [Services.DEEZER, "Deezer"],
  [Services.LASTFM, "Last.fm"]
]);
